import { render, staticRenderFns } from "./TerminationWizard.vue?vue&type=template&id=4268c2b6"
import script from "./TerminationWizard.vue?vue&type=script&lang=js"
export * from "./TerminationWizard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports